export default __webpack_public_path__ + "app/images/cee7439ad3e4fe358f4f3a2fcfefb74e.png";